import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUserSession, logout } from 'actions/authentication';
import { getCreditApplication, getCreditApplicationStatus } from 'actions/selfservice';
import history from 'router/history';
import CreditApplicationStateAU from 'components/Credit24/SelfService/CreditApplicationStateAU';
import CreditApplicationStateFI from 'components/Credit24/SelfService/CreditApplicationStateFI';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  selfservice: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  getUserSession: PropTypes.func.isRequired,
  getCreditApplicationStatus: PropTypes.func.isRequired,
  getCreditApplication: PropTypes.func.isRequired,
};

const continueApplication = () => (
  window.location = `/${COUNTRY.toLowerCase()}/apply/${location.search}`
);

class CreditApplicationStateContainer extends Component {
  constructor() {
    super();
    this.getCreditApplicationStatus = this.getCreditApplicationStatus.bind(this);
  }

  componentDidMount() {
    const { authentication: { contracts } } = this.props;

    let shouldRedirectToIndex = contracts.length > 0;
    if (!shouldRedirectToIndex) {
      this.props.getCreditApplication();
    } else if (COUNTRY === 'FI') {
      const { selfservice: { creditApplicationState } } = this.props;
      if (creditApplicationState === 'PENDING_CL_UPGRADE') {
        shouldRedirectToIndex = false;
        this.getCreditApplicationStatus();
      }
    }

    if (shouldRedirectToIndex) {
      history.replace('/');
    }
  }

  componentDidUpdate(prevProps) {
    if (COUNTRY === 'FI') {
      const { selfservice: { creditApplicationState } } = this.props;
      if (
        creditApplicationState !== prevProps.selfservice.creditApplicationState
        && creditApplicationState === 'PENDING'
      ) {
        this.getCreditApplicationStatus();
      }
    }
  }

  getCreditApplicationStatus() {
    window.setTimeout(
      () => {
        const { authentication } = this.props;
        this.props.getCreditApplicationStatus(
          (responseData) => {
            const { contractId } = responseData;
            if (contractId && contractId !== authentication.contracts[0]) {
              this.props.getUserSession();
            } else if (responseData.state === 'APPROVED') {
              history.replace('/');
            } else {
              this.getCreditApplicationStatus();
            }
          }
        );
      },
      5000
    );
  }

  render() {
    const { selfservice: { creditApplicationState } } = this.props;

    if (!creditApplicationState) {
      return <span />;
    }

    if (COUNTRY === 'FI') {
      return (
        <CreditApplicationStateFI
          logout={this.props.logout}
          creditApplicationState={creditApplicationState}
          continueApplication={continueApplication}
          isPendingState={
            creditApplicationState === 'PENDING_CL_UPGRADE' || creditApplicationState === 'PENDING'
          }
        />
      );
    }

    if (COUNTRY === 'AU') {
      return (
        <CreditApplicationStateAU
          logout={this.props.logout}
          creditApplicationState={creditApplicationState}
        />
      );
    }

    return null;
  }
}

CreditApplicationStateContainer.propTypes = propTypes;

export default connect(
  (state) => ({
    authentication: state.authentication,
    selfservice: state.selfservice,
  }),
  {
    getUserSession, logout, getCreditApplication, getCreditApplicationStatus,
  }
)(CreditApplicationStateContainer);
